<template>
    <Popup :show="show" v-on:closeEvent="close">
        <div class="popup-container" v-if="isSelectedProduct">
        <h2>{{$t("shop.LBL_POPUP_TITLE")}}</h2>
        <div class="wrap-text">
            <span class="product-count">{{$tc("shop.LBL_POPUP_PRODUCT",selectedProduct.qty,{count:selectedProduct.qty})}}</span>
            <span class="product-count">{{formatPrice(round2(selectedProduct.price.regular),selectedProduct.currency?selectedProduct.currency:null)}}</span>
        </div>
        <div class="wrap-text" v-if="selectedProduct.price.discount">
            <span class="product-sale">{{$t("shop.LBL_POPUP_DISCOUNT",{discount:selectedProduct.price.discount})}}</span>
            <span class="product-sale">-{{formatPrice(round2(selectedProduct.price.regular - selectedProduct.price.sale),selectedProduct.currency?selectedProduct.currency:null)}}</span>
        </div>
        <div class="wrap-text">
            <span class="total-text">{{$t("shop.LBL_POPUP_TOTAL")}}</span>
            <span class="total-text">{{formatPrice(round2(finalProductPrice),selectedProduct.currency?selectedProduct.currency:null)}}</span>
        </div>
        <div class="wrap-text" :style="{opacity: rateLoaded?1:0}" v-if="typeof selectedProduct.currency == 'undefined' || !selectedProduct.currency || selectedProduct.currency != 'MDL'">
            <span class="product-sale">Echivalentul în MDL (1 {{user.currency}} = {{round2(rateEURtoLEI)}} MDL)</span>
            <span class="product-sale">{{formatPrice(round2(rateEURtoLEI*finalProductPrice),"mdl")}}</span>
        </div>
        <span class="text" :style="{color: isReadText?'#CF0920':'#0B1022'}">{{$t("shop.LBL_POPUP_PAYMENT_METHOD")}}</span>
        <div class="hours-wrapper">
            <div v-for="(method,index) in methods" :key="method.id" @click="selectedMethodEvent(method)"
                :class="[
                'hour-item',
                method.id === selectedMethodId ? 'active' : null,
                ]"
            >
                <div class="circle">
                    <div></div>
                </div>
                <span>{{method.text}}</span>
            </div>
        </div>
        <span class="text" v-html="$t('shop.LBL_POPUP_HELPER')"></span>
        <div class="promocode">
            <div class="field-wrapper">
                <span class="text" style="#CF0920">{{$t("shop.LBL_ENTER_PROMOCODE")}}</span>
                <div class="input-wrapper">
                    <input type="text" v-model="promocode" />
                </div>
            </div>
        </div>
        <div class="buttons">
            <button class="button cancel-button" @click="close">
                <span>{{$t("strings.BTN_CANCEL")}}</span>
            </button>
            <button
                :class="[
                'button',
                selectedMethodId === '' ? 'cancel-button' : null,
                ]"
                @click="ok">
                <span>{{$t("strings.BTN_CONFIRM")}}</span>
            </button>
        </div>
        </div>
    </Popup>
</template>

<script>
    import store from '@/store';
    import Popup from '../../../../components/Popup';
    import i18n from "@/i18n";
    import {rest,formatPrice} from "@/utils/utils";
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: "PayMethodPopup",
        components: {
            Popup
        },
        props: {
            show: {
                type: Boolean,
                required: true
            },
            selectedProduct: {
                type: Object,
                required: false
            }
        },
        data: function () {
            return {
                isReadText: false,
                selectedMethodId: '',
                rateEURtoLEI: 0,
                rateLoaded: false,
                methods: [
                {
                    id: 'maib',
                    text: i18n.t("shop.LBL_PAYMENT_METHOD_CARD")
                },
                {
                    id: 'paypal',
                    text: i18n.t("shop.LBL_PAYMENT_METHOD_PAYPAL")
                }
                ],
                promocode:""
            }
        },
        computed: {
            isSelectedProduct() {
                return this.selectedProduct !== null
            },
            finalProductPrice() {
                return this.selectedProduct.price.discount ? this.selectedProduct.price.sale : this.selectedProduct.price.regular
            },
            ...mapGetters({
                user: 'user/get',
            }),
        },
        mounted() {
            this.getRateEURtoLEI();
            this.getPromocode();
        },
        methods: {
            round2(num) {
                return Math.round(num * 100) / 100;
            },
            getRateEURtoLEI() {
                this.rateLoaded = false;
                store.commit('loading/is', true);
                rest.call("get_currency_value",{
                    "from":this.user.currency,
                    "to":"MDL",
                },"GET").then((response)=>{
                    if(response){
                        this.rateEURtoLEI = response.rate;
                    }
                    store.commit('loading/is', false);
                    this.rateLoaded = true;
                }).catch((error)=>{
                    this.rateLoaded = true;
                    store.commit('loading/is', false);
                });
            },
            getPromocode(){
                store.commit('loading/is', true);
                rest.call("get_promocode",{},"GET").then((response)=>{
                    if(response && response.code){
                        this.promocode = response.code;
                    }
                    store.commit('loading/is', false);
                }).catch((error)=>{
                    store.commit('loading/is', false);
                });
            },
            selectedMethodEvent(method) {
                this.selectedMethodId = method.id;
                this.isReadText = false;
            },
            close() {
                this.$emit('closeEvent', null);
                this.selectedMethodId = '';
                this.isReadText = false;
            },
            ok() {
                if (this.selectedMethodId !== '') {
                    this.$emit('closeEvent', null);
                    this.$emit('paymentEvent', {
                        id: this.selectedProduct.id,
                        qty: this.selectedProduct.qty, // quantity
                        rateEURtoLEI: this.rateEURtoLEI,
                        payment_method: this.selectedMethodId,
                        offer:this.selectedProduct.offer,
                        offer_product_id:this.selectedProduct.offer_product_id,
                        promocode:this.promocode
                    });
                } else {
                    this.isReadText = true;
                }
            },
            formatPrice(value,currency=null){
                currency = currency?currency:this.user.currency;
                return formatPrice(value,currency);
            },
        },
    }
</script>

<style scoped lang="scss">

    .popup-container {
        width: 100%;
        align-self: auto;
        display: flex;
        flex-direction: column;
    }

    h2 {
        font-family: FuturaPT;
        font-size: 32px;
        line-height: 32px;
        letter-spacing: 0.1rem;
        color: #0B1022;
    }

    .wrap-text {
        display: flex;
        justify-content: space-between;
    }

    .product-count {
        font-family: FuturaPT;
        font-size: 20px;
        line-height: 36px;
        letter-spacing: 0.05rem;
        color: #0B1022;
        margin-top: 3.3rem;
    }

    .product-sale {
        font-family: FuturaPT;
        font-size: 20px;
        line-height: 36px;
        letter-spacing: 0.05rem;
        color: rgba(11, 16, 34, 0.3);
        margin-top: 0.5rem;
    }

    .total-text {
        font-family: FuturaPT;
        font-size: 16px;
        line-height: 20px;
        letter-spacing: 0.5px;
        color: #0B1022;
        margin-top: 1.5rem;
    }

    .text {
        font-family: FuturaPT;
        font-size: 1.6rem;
        line-height: 2rem;
        letter-spacing: 0.1rem;
        color: rgba(11, 16, 34, 0.3);
        margin-top: 2.5rem;
    }

    @media (max-width: 590px) {
	.product-count, .product-sale, .total-text{
        font-size: 11px;
        line-height: 20px;
        }
        }

    .hours-wrapper {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-wrap: wrap;

        .hour-item {
        cursor: pointer;
        padding: 1.5rem 3.6rem 1.5rem 5.6rem;
        border-radius: 1rem;
        background: #F0F3F8;
        display: flex;
        align-items: center;
        transition: all 0.2s cubic-bezier(0.25, 0.8, 0.25, 1);
        margin-top: 0.5rem;
        margin-right: 0.5rem;
        position: relative;
        width: 207px;
        height: 45px;

        .circle {
            width: 17px;
            height: 17px;
            display: flex;
            justify-content: center;
            align-items: center;
            border: 2px solid #0B1022;
            border-radius: 100px;
            margin-right: 16px;
            left:5px;
            top: 50%;
            transform: translateY(-50%);
            position: absolute;
            background:transparent;
            div {
                border-radius: 100px;
                width: 11px;
                height: 11px;
                display: none;
            }
        }

        span {
            font-family: FuturaPT;
            font-size: 20px;
            line-height: 18px;
            letter-spacing: 0.5px;
            color: #0B1022;
            margin-left: 18px;
        }

        &:hover {
            box-shadow: 0px 2px 4px #D1D1D1;
        }

        &.active {
            box-shadow: 0px 2px 4px #D1D1D1;
            background-color: #CF0920;

            .circle {
            border: 2px solid white;

            div {
                display: block;
                background-color: white;
            }
            }

            span {
            color: white;
            }
        }
        }
    }

    .buttons {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        margin-top: 2rem;

        .cancel-button {
        background: #F0F3F8;
        color: #000;
        }

        .button {
        margin-left: 0.8rem;
        padding: 0.75rem 2.5rem 1rem 2.5rem;
        }
    }
    .promocode{
        margin: 1rem 0rem 2rem;
        .field-wrapper{
            &>span{
                margin-bottom: 1rem;
                display: block;
            }
            .input-wrapper{
                input{
                    width: 100%;
                    max-width: 100%;
                    height: 45px;
                }
            }
        }
    }
</style>
